var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0H19.75C20.2188 0 20.6875 0.3125 20.875 0.75C21.0938 1.21875 21 1.75 20.6562 2.125L16 7.1875V12C16 12.4062 15.7812 12.75 15.4375 12.9062C15.0938 13.0625 14.6875 13.0312 14.375 12.8125L12.375 11.3125C12.125 11.125 12 10.8438 12 10.5V7.1875L7.3125 2.125C6.96875 1.75 6.90625 1.21875 7.09375 0.75C7.28125 0.3125 7.75 0 8.25 0ZM2.25 2H6.125C6.21875 2.28125 6.375 2.5625 6.59375 2.78125L11 7.5625V8.09375L10 9.1875V13C10 13.4062 9.78125 13.75 9.4375 13.9062C9.09375 14.0625 8.6875 14.0312 8.375 13.8125L6.375 12.3125C6.125 12.125 6 11.8438 6 11.5V9.1875L1.3125 4.125C0.96875 3.75 0.90625 3.21875 1.09375 2.75C1.28125 2.3125 1.75 2 2.25 2Z",
    fill: "url(#paint0_linear_3098_16156)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3098_16156",
    x1: 11,
    y1: -3,
    x2: 11,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2B63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.f5d49933b4f60305824db21c888716db.svg";
export { ForwardRef as ReactComponent };